var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 8L5 8V6L19 6V8Z",
    fill: "#80919F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12L12 12V10L5 10V12Z",
    fill: "#80919F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21871 20.3553L5.56765 22.7851C5.22275 23.1012 4.66663 22.8565 4.66663 22.3887V18H4C2.34315 18 1 16.6569 1 15V3C1 1.34315 2.34315 0 4 0H20C21.6569 0 23 1.34315 23 3V15C23 16.6569 21.6569 18 20 18H10.6321L8.21871 20.3553ZM6.66663 16V19.0649L6.84425 18.9021L9.81787 16H20C20.5523 16 21 15.5523 21 15V3C21 2.44772 20.5523 2 20 2H4C3.44772 2 3 2.44772 3 3V15C3 15.5523 3.44772 16 4 16H6.66663Z",
    fill: "#80919F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.1c796d3348fc0db2be2a739981f4e203.svg";
export { ForwardRef as ReactComponent };